import { io } from "socket.io-client";

const primaryURL = process.env.REACT_APP_PRIMARY_BASE_URL;
const secondaryURL = process.env.REACT_APP_SECONDARY_BASE_URL;

export const connectSocket = () => {
    const usePrimary = localStorage.getItem('usePrimaryServer') !== 'false';
    const baseURL = usePrimary ? primaryURL : secondaryURL;

    let socket = io(baseURL, {
        transports: ['websocket'], // Optional: helps avoid polling fallback
        withCredentials: true
    });

    socket.on("connect_error", () => {
        const fallbackURL = usePrimary ? secondaryURL : primaryURL;
        socket = io(fallbackURL, {
            transports: ['websocket'],
            withCredentials: true
        });
    });

    return socket;
};
